import { Theme } from "@mui/material/styles";
import { customScrollbar } from "src/theme/shared/scrollbar";

export const sxColumnFlex = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column'
};

export const sxItemsContainer = (theme: Theme) => ({
  ...sxColumnFlex,
  my: 2.5,
  ...customScrollbar(theme),
})

export const sxSkeleton = {
  paddingLeft: 3,
  paddingRight: '18px',
};

export const sxAvatarBase = {
  width: '64px',
  height: '64px',
};

export const sxSendIcon = {
  position: 'absolute',
  zIndex: 1000,
  left: '50%',
  top: '50%',
  transform: 'translate(-50%,-50%)',
  ml: 0.5,
  mt: 0.5,
};

export const sxDisabled = {
  opacity: 0.48,
};

export const sxActiveFilter = {
  my: 2.5,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};
